import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';

@Injectable({
  providedIn: 'root',
})
export class MixpanelService {
  constructor() {
    mixpanel.init('f9198c430f7de76306ceaf92180e3971');
  }
  
  track(eventName: string, properties?: { [key: string]: any }) {
    if (properties?.['distinct_id']) {
      mixpanel.identify(properties['distinct_id']);
    }
  
    mixpanel.track(eventName, properties);
    console.log(`Mixpanel event tracked: ${eventName}`, properties || '');
  }
}
